export default __webpack_public_path__ + "static/default-plan-image-332138c1e70d98ed1fc7afbbb9b52abe.jpg";